"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiCube, PiBrain, PiNetwork } from "react-icons/pi";

export default function AIFeatures({
  content,
  onContentChange,
  isSelected,
}: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const features = content.features || [
    { title: "Neural Networks", description: "Deep learning models tailored for specific industry datasets.", icon: "brain" },
    { title: "Autonomous Agents", description: "Intelligent workflows that plan and solve complex tasks.", icon: "network" },
    { title: "Scale Infrastructure", description: "High-performance nodes hosting custom weight arrays.", icon: "cube" }
  ];

  const iconMap: Record<string, any> = {
    brain: <PiBrain className="w-6 h-6 text-purple-400" />,
    network: <PiNetwork className="w-6 h-6 text-purple-400" />,
    cube: <PiCube className="w-6 h-6 text-purple-400" />,
  };

  return (
    <section
      className={`py-24 px-6 bg-black text-white transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        <div className="text-center space-y-4 max-w-xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight">
            <EditableText
              value={content.title || "Engineered for Intelligence"}
              onChange={(val) => onContentChange?.({ ...content, title: val })}
              as="span"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feat: any, idx: number) => (
            <div key={idx} className="bg-slate-950/40 p-8 rounded-2xl border border-purple-950/30 space-y-4 hover:border-purple-900/40 transition-all">
              <div className="w-12 h-12 rounded-xl bg-purple-950/20 border border-purple-900/30 flex items-center justify-center">
                {iconMap[feat.icon] || <PiCube className="w-6 h-6 text-purple-400" />}
              </div>
              <h3 className="text-xl font-bold">{feat.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
